module.exports = __webpack_public_path__ + "img/digital.c85675d9.svg";